module.exports = __webpack_public_path__ + "img/Orderbg2.bffff8c7.png";